import Swiper from './swiper.min.js';
import Pagination from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/pagination.min.mjs';
import Navigation from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/navigation.min.mjs';

class ProductCards extends HTMLElement {
    constructor() {
      super()
      this.runScript()
    }
    runScript() {
      const self = this
      document.querySelectorAll('.product-grid-item').forEach(function(product) {
        let id = product.dataset.id
        
        self.getVariant(product, id)

        product.querySelectorAll('select').forEach(function(select) {
          select.addEventListener('change', function() {
            self.getVariant(product, id)
          })
        })
      })

      self.renderSlide()
    }
    centsToMoneyFormat(cents, currency = 'USD') {
      const dollars = cents / 100; // Convert cents to dollars
    
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
      minimumFractionDigits: 2, // Ensure at least 2 decimal places
      maximumFractionDigits: 2,
      });
    
      return '$ ' + formatter.format(dollars);
    }

    getVariant(product, id) {
      let variants

      if(window.recentlyViewedItems) {
        variants = recentlyViewedItems.filter(item => item.id == id)[0].variants
      } else {
        variants = productsData.filter(item => item.id == id)[0].variants
      }
      
      let selectedVariant = variants

      product.querySelectorAll('select').forEach(function(select, i) {
        let selectedOption = select.options[select.selectedIndex]?.dataset.title
        
        if(selectedOption) {
          selectedVariant = selectedVariant.filter(item => item.title.includes(selectedOption))

          if(i == 0) {
            let disabledOptions = selectedVariant.filter(item => !item.available)

            product.querySelectorAll('option').forEach(option => option.disabled = false)

            product.querySelectorAll('option').forEach(function(option) {
              if(disabledOptions.filter(item => item.title.includes(option.dataset.title)).length) {
                option.disabled = true
              }
            })
            product.querySelectorAll('select')[0].querySelectorAll('option').forEach(option => option.disabled = false)
          }
        }
      })
      selectedVariant = selectedVariant[0]

      if(selectedVariant.available) {
        product.querySelector('.product-grid-item_atc').innerHTML = 'Add To Cart'
        product.querySelector('.product-grid-item_atc').disabled = false

        product.querySelector('.product-grid-item_atc').addEventListener('click', function() {
          let formData = {
            items: [
              {
                id: selectedVariant.id,
                quantity: 1,
              },
            ],
          }
      
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              let sidecart = document.querySelector('side-cart')
              sidecart?.openCart()
            })
            .catch((error) => {
              console.error('Error:', error)
            })
        })

      } else {
        product.querySelector('.product-grid-item_atc').innerHTML = 'sold out'
        product.querySelector('.product-grid-item_atc').disabled = true
      }

      product.querySelector('.product-grid-item_price').innerHTML = this.centsToMoneyFormat(selectedVariant.price) 
    }

    renderSlide() {
      const self = this
      if(window.innerWidth > 1024) {
        const swiper = new Swiper(this, {
          slidesPerView: 4,
          spaceBetween: 16,
          loop: true,
          modules: [ Pagination, Navigation ],
          pagination: {
              el: self.querySelector('.swiper-pagination'),
          },
          
          // Navigation arrows
            navigation: {
            nextEl: self.closest('.container').querySelector('.swiper-button-next'),
            prevEl: self.closest('.container').querySelector('.swiper-button-prev'),
          }
        })
      }
      
    }
  }
  
  customElements.define('product-cards', ProductCards)